import React, { Component } from 'react';

import { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import Paper from '@material-ui/core/Paper';
import { MyPATLink } from '../../common';
import BackIcon from '@material-ui/icons/KeyboardBackspace';
import CourseMainPageCard from "../components/CourseMainPageCard";
import AdvanceSettingContent from "../components/AdvancedSetting/AdvanceSettingContent"
import courseService from '../services/courseService';
import { showMsg } from '../actions/loaderAlert';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import _ from 'lodash';
import MoreVertModalss from '../components/more_vertModalss';
import { styles } from '../styling/AdvanceSettingMilestone'
import ContentMoreMenu from '../components/CourseDetail/ContentMoreMenu'
import advanceSetting from "../services/advancedSettingService"
import { getCourseID } from '../components/CourseDetail/commonFunction';
import {
	Edit as EditIcon,
} from '@material-ui/icons';
import { CourseBasicInfo } from '../modals/CourseBasicInfo';
import ResponseBasedACL from '../../acl/components/ResponseBasedACL';

interface AdvanceSettingProps extends WithStyles<typeof styles> {
	courseData: CourseBasicInfo,
	showMsg: (msg: string, vari: string) => void,
	match: any
}

interface AdvanceSettingStates {
	hasContent: Boolean,
	previewMode: boolean,
	batchesData: any[],
	cardFlag: string
	batchActive: any,
	instructorData: {
		key: any,
		value: any
	},
	course_data : any,
	subjectRemove: number,
}

class AdvanceSettingMilestone extends Component<AdvanceSettingProps, AdvanceSettingStates> {
	constructor(props: AdvanceSettingProps) {
		super(props);

		this.state = {
			hasContent: true,
			previewMode: false,
			batchesData: [],
			cardFlag: "",
			batchActive: "",
			instructorData: {
				key: '',
				value: ''
			},
			course_data : '',
			subjectRemove: 0,
		};

		this.publishPackage = this.publishPackage.bind(this)
		this.previewMode = this.previewMode.bind(this)
		this.setAddedBatchesData = this.setAddedBatchesData.bind(this)
		this.toggleInstructorBatchCard = this.toggleInstructorBatchCard.bind(this);
		this.toggleInstructorBatchCardWithKeyAndValue = this.toggleInstructorBatchCardWithKeyAndValue.bind(this);
		this.backToBatch= this.backToBatch.bind(this);
		this.setCountSubjectRemove = this.setCountSubjectRemove.bind(this);

	}
	componentWillMount(){
		let courseId = this.props.match.params.id;

		courseService.getPackageBasicInfo(courseId)
		.then((course_data : any) => {
			this.setState({course_data : course_data});
		});
	}
	componentDidMount() {
		this.getMandatoryTags();
		(this.props.courseData).status == "PUBLISHED" ? this.setState({ previewMode: true }) : this.setState({ previewMode: false })
		this.toggleInstructorBatchCard("");

		let { batchesData } = this.state;
		let { courseData } = this.props;

		// get course data from props or localstorage
		if (_.isEmpty(courseData)) {
			courseData = JSON.parse(localStorage.getItem("myPatCourse") || "");
		}
		// get batch details
		const batches = _.get(courseData, 'setting.batches', []);
		
		if(_.isEmpty(batchesData)) {
			this.setState({ batchesData: batches });
		}
	}

	previewMode() {
		this.setState({
			previewMode: !this.state.previewMode
		})
	}

	getMandatoryTags() {
		advanceSetting.getMandatoryTags().then((responseData: any) => {
			if (!_.isEmpty(responseData)) {
			}
		});
	}

	publishPackage() {
		var self = this;
		var courseID = this.props.match.params.id || getCourseID()

		courseService.publishPackage(courseID).then((responseData: any) => {

			if (responseData.statusCode === 200) {
				if (!_.isEmpty(responseData.responseObject)) {
					self.props.showMsg(responseData.data, 'success');
				}
			} else {
				self.props.showMsg(responseData.data, 'error');
			}
		});
	}

	setAddedBatchesData(addedBatches: any,	) {
		

		this.setState({
			batchesData: addedBatches,
			
		})
		
	}

	setCountSubjectRemove(){
		let {subjectRemove} = this.state;
		this.setState({
			subjectRemove: subjectRemove + 1
		});

	}

	toggleInstructorBatchCard(flag: string) {
		//value for intructor card
		//batch for batch card		
		this.setState({
			cardFlag: flag,
			instructorData: { key: "", value: "" }
		});
	}

	toggleInstructorBatchCardWithKeyAndValue(key:any, value:any) {
		let { batchesData } = this.state;
		let { courseData } = this.props;
		
		// get course data from props or localstorage
		if (_.isEmpty(courseData)) {
			courseData = JSON.parse(localStorage.getItem("myPatCourse") || "");
		}

		// get batch details
		const batches = _.get(courseData, 'setting.batches', []);
		const selectedBatch = _.find(batches, ['_id', key]);

		// update batchesdata if not found in array
		if (_.isEmpty(_.find(batchesData, ['_id', key]))) {
			batchesData.push(selectedBatch);
		}

		this.setState({
			instructorData: {
				key,
				value
			},
			cardFlag: key,
			batchesData
		});
		window.scrollTo(0, document.body.scrollHeight);
	}

	fromShareModelReturn(value: string) {
		var self = this;
		if (value == "Share") {
			// this.setState({
			// 	isShareDialogOpen:true
			// })
		} else if (value == "Comment") {
			// this.setState({
			// 	isCommentDialogOpen:true
			// })
		} else if (value == "Copy Course") {
			courseService.copyCourse(this.props.match.params.id).then((response: any) => {
				self.props.showMsg("Course Successfully copied", 'success');
			});
		}
	}
	toggleBatchToInstructor(){

	}

	backToBatch = () => this.setState({cardFlag : ""})
	
	render() {
		let { classes, courseData, match } = this.props;
		let { previewMode, cardFlag, instructorData: { key: instructorKey, value: instructorValue}, course_data,subjectRemove } = this.state
		var courseID = match.params.id || getCourseID()

		if (_.isEmpty(courseData)) {
			courseData = JSON.parse(localStorage.getItem("myPatCourse") || "")
		}

		if (_.isEmpty(courseData)) {
			return ""
		}

		return (
			<>
				<Grid container
					spacing={0}
					direction="column"
					className={classes.root}>
					<Grid item xs={12} className={classes.wrapperMain}>

						<Grid xs={12}	
							container
							direction="row"
							alignContent="center"
							justify="space-between"
						>
							<Grid xs={4}>
								{
								(cardFlag !== "") 
								?
								<Typography variant="h6" style={{ padding: "10px" }}>

										<BackIcon onClick={this.backToBatch}/> Course Advanced Settings
								</Typography>
								:
								<MyPATLink to={`/course/detail/${courseID}`}>
									<Typography variant="h6" style={{ padding: "10px" }}>

										<BackIcon /> Course Advanced Settings
								</Typography>
								</MyPATLink>
								}
							</Grid>
							<Grid xs={6} container justify="flex-end" alignItems="flex-end">
								<ResponseBasedACL
									response={_.get(courseData, 'aclMetaData', {})}
									responseKey='allowedTo'
									accessType={['EDIT']}
								>
									<Button
										variant="outlined"
										// disabled={previewMode ? false : true}
										disabled={true}
										onClick={this.previewMode}
									>
										<div className={classes.editText}>
											<EditIcon className={classes.editTextIcons} />
										</div>
										Edit
									</Button>
								</ResponseBasedACL>
								<ResponseBasedACL
									response={_.get(courseData, 'aclMetaData', {})}
									responseKey='allowedTo'
									accessType={['EDIT']}
								>
									<Button
										variant="contained"
										type="submit"
										color="primary"
										// disabled={previewMode ? true : (courseData.draftCompletionPercentage == 100 ? false : true)}
										disabled={true}
										onClick={this.publishPackage}
										style={{ marginLeft: "25px" }}
									>
										Publish
									</Button>
								</ResponseBasedACL>
								{
									courseData.draftCompletionPercentage != 100 && courseData.status == "DRAFT"
										?
										<div className={classes.incompleteDraft}>
											<Typography variant="caption">Incomplete Draft</Typography>
										</div>
										:
										<></>
								}
								<div style={previewMode ? { pointerEvents: 'none' } : {}}>
									{/* <ContentMoreMenu clicked={this.fromShareModelReturn} /> */}
									<MoreVertModalss />

								</div>

								<Grid item xs={1} className={classes.vertHeaderActions}>
									{/* <MoreVertModals /> */}
								</Grid>
							</Grid>
						</Grid>


						<div key={1}>
							<Paper elevation={0} style={{ marginBottom: 10 }}>
								<ListItem>
									<CourseMainPageCard cardDetails={courseData} cardFlag={cardFlag} 
									batchesData ={this.state.batchesData} 
									handleBatchClick={this.toggleInstructorBatchCardWithKeyAndValue}   
									setAddedBatchesData={this.setAddedBatchesData}/>
								</ListItem>
							</Paper>
						</div>
					</Grid>
				</Grid>
				<AdvanceSettingContent
					batchesData ={this.state.batchesData}
					toggleInstructorBatchCard={this.toggleInstructorBatchCard}   
					setAddedBatchesData={this.setAddedBatchesData} 
					setCountSubjectRemove={this.setCountSubjectRemove}
					subjectRemoved={subjectRemove} 
					previewMode={previewMode} courseID={courseID}
					instructorKey={instructorKey}
					instructorValue={instructorValue}
					cardDetails={course_data}
					cardFlag={cardFlag}
				/>
			</>
		)
	}
}


const mapStateToProps = (state: any) => ({
	courseData: state.courseData.courseData.list
});


const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
		showMsg: showMsg
		// ServerAlertAction
	},
	dispatch
);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AdvanceSettingMilestone));
